import React from 'react';
import ProjectBox from './ProjectBox';


const Projects = () => {
  
  return (
    <div>
      <h1 className='projectHeading'>My <b>Projects</b></h1>
      <div className='project'>
        <ProjectBox projectName="ZCoder" />
        <ProjectBox projectName="ANOMALISE" />
        <ProjectBox projectName="ShroudX" />
        <ProjectBox projectName="MIPS Simulator" />
        <ProjectBox projectName="CDN Optimisation" />
        <ProjectBox projectName="Tiny Trolly" />
      </div>
    </div>
  );
  
}

export default Projects